import TableWithSkeleton from "../../../../components/global/table/TableWithSkeleton.jsx";

export default function TopPerformingAgentsTable({
  columns,
  data,
  loading,
  rowKey = "agentId",
}) {
  return (
    <div className="border-2 border-light rounded-[10px] p-5 overflow-hidden">
      <h2 className="text-title font-semibold mb-4">Top Performing Agents</h2>
      <div className="overflow-hidden rounded-[10px]">
        <TableWithSkeleton
          showIndexColumn={false}
          pagination={false}
          rowKey={rowKey}
          columns={columns}
          data={data}
          loading={loading}
        />
      </div>
    </div>
  );
}
